import styled from "styled-components"

import { SPACING } from "../../../../../component-library/design/spacing/spacing.constants"
import { HeadingSmall } from "../../../../../component-library/design/typography/typography.styles"

const StyledWrapper = styled.div`
  margin: ${SPACING.M} 0;
`

const StyledSubheading = styled(HeadingSmall)`
  margin-bottom: ${SPACING.S};
`

export { StyledWrapper, StyledSubheading }
